var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0904 14.4H17.7571V5.06667C17.7571 4.64233 17.5885 4.23536 17.2885 3.9353C16.9884 3.63525 16.5815 3.46667 16.1571 3.46667C15.7328 3.46667 15.3258 3.63525 15.0257 3.9353C14.7257 4.23536 14.5571 4.64233 14.5571 5.06667V14.4H5.22378C4.79943 14.4 4.39247 14.5686 4.09241 14.8686C3.79235 15.1687 3.62378 15.5757 3.62378 16C3.62378 16.4244 3.79235 16.8313 4.09241 17.1314C4.39247 17.4314 4.79943 17.6 5.22378 17.6H14.5571V26.9333C14.5571 27.3577 14.7257 27.7647 15.0257 28.0647C15.3258 28.3648 15.7328 28.5333 16.1571 28.5333C16.5815 28.5333 16.9884 28.3648 17.2885 28.0647C17.5885 27.7647 17.7571 27.3577 17.7571 26.9333V17.6H27.0904C27.5148 17.6 27.9218 17.4314 28.2218 17.1314C28.5219 16.8313 28.6904 16.4244 28.6904 16C28.6904 15.5757 28.5219 15.1687 28.2218 14.8686C27.9218 14.5686 27.5148 14.4 27.0904 14.4Z",
    fill: "#989BA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusMono);
export default __webpack_public_path__ + "static/media/icon-plus-mono.04f71e9d7ad0b8b0b7e6b6f154c92635.svg";
export { ForwardRef as ReactComponent };